import React from 'react';
import { Content, Flex, Text, Button, Pane } from '@leverege/ui-elements';
import { DataSources } from '@leverege/ui-attributes';
import { GlobalState } from '@leverege/ui-redux';
import { TitleBar } from '@leverege/ui-plugin';
import { LoadingView } from '@leverege/molten/views';
import Detail from '../Detail';
import S from '../../PairForm.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default class LocatorElsewhere extends React.Component {
  onChangeLocation = async evt => {
    const {
      onOkay,
      location,
      selectedObject
    } = this.props;
    const {
      locator
    } = selectedObject;
    const loc = {
      ...location,
      ref: location.ref.substring(0, location.ref.lastIndexOf('/')),
      type: 'location'
    };
    const actions = DataSources.getActions(loc);
    const closeLoading = LoadingView.showDialog(`Moving ${locator?.data?.serialNumber}...`);
    try {
      await GlobalState.dispatch(actions.child('locators').create({
        id: locator.id,
        force: true
      }));
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('err', err);
    }
    closeLoading();
    onOkay?.(evt);
  };
  render() {
    const {
      areaClassName,
      footerClassName,
      onClose,
      selectedObject,
      titleVariant,
      titleIcon
    } = this.props;
    const {
      location
    } = selectedObject;
    return /*#__PURE__*/_jsxs(React.Fragment, {
      children: [/*#__PURE__*/_jsx(Content.Header, {
        children: /*#__PURE__*/_jsx(TitleBar, {
          variant: titleVariant,
          title: "Pair Locator to Vehicle",
          icon: titleIcon,
          children: /*#__PURE__*/_jsx(Button, {
            variant: "closeDialog",
            className: S.close,
            onClick: onClose
          })
        })
      }), /*#__PURE__*/_jsx(Content.Area, {
        className: areaClassName,
        children: /*#__PURE__*/_jsxs(Flex, {
          variant: "colL",
          children: [/*#__PURE__*/_jsx("img", {
            className: S.locatorError,
            src: "https://recovr-ui-assets.storage.googleapis.com/locator-elsewhere.png",
            alt: "Locator warning",
            height: 92,
            width: 136
          }), /*#__PURE__*/_jsx(Text, {
            variant: "formTitle",
            children: "Locator at Another Location"
          }), /*#__PURE__*/_jsx(Text, {
            children: "This locator is currently in another location. To move it to this location, click the override button below."
          }), /*#__PURE__*/_jsx(Pane, {
            variant: "dashboardCard",
            children: /*#__PURE__*/_jsx(Pane, {
              layout: "flex:col",
              variant: "dataCard",
              children: /*#__PURE__*/_jsx(Detail, {
                className: S.detailPair,
                label: "Current Location",
                value: location?.data?.name || 'Unknown'
              })
            })
          })]
        })
      }), /*#__PURE__*/_jsxs(Content.Footer, {
        className: footerClassName,
        layout: "flex:rowMEnd",
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: onClose,
          variant: "secondary",
          children: "Cancel"
        }), /*#__PURE__*/_jsx(Button, {
          variant: "primary",
          onClick: this.onChangeLocation,
          children: "Change Location & Pair"
        })]
      })]
    });
  }
}